import { useQueries, useQuery } from "@tanstack/react-query";
import type { LimitedUseRxNavQueryOptions, RxNavQueryKey, RxNavQueryRequests } from "./types";

export interface UseRxNavNdcCodeQueryArgs<TError = Error, TData = RxNavQueryRequests["ndc-code"]["response"]>
  extends LimitedUseRxNavQueryOptions<"ndc-code", TError, TData> {}

export const useRxNavNdcCodesQuery = <TError = Error, TData = RxNavQueryRequests["ndc-code"]["response"]>({
  request,
  ...options
}: UseRxNavNdcCodeQueryArgs<TError, TData>) =>
  useQuery({
    queryKey: ["rx-nav", "ndc-code", request],
    queryFn: async () => {
      const url = encodeURI(`https://rxnav.nlm.nih.gov/REST/rxcui/${request.rxNormCode}/ndcs.json`);
      const result = await fetch(url);
      return await result.json();
    },
    ...options,
  });

export interface UseRxNavNdcCodesQueriesArgs<TError = Error, TData = RxNavQueryRequests["ndc-code"]["response"]>
  extends Omit<UseRxNavNdcCodeQueryArgs<TError, TData>, "request"> {
  request: {
    rxNormCodes: string[];
  };
}

export const useRxNavNdcCodesQueries = <TError = Error, TData = RxNavQueryRequests["ndc-code"]["response"]>({
  request,
  ...options
}: UseRxNavNdcCodesQueriesArgs<TError, TData>) =>
  useQueries({
    queries: request.rxNormCodes.map((rxNormCode) => ({
      queryKey: ["rx-nav", "ndc-code", { rxNormCode }] satisfies RxNavQueryKey<"ndc-code">,
      queryFn: async () => {
        const url = encodeURI(`https://rxnav.nlm.nih.gov/REST/rxcui/${rxNormCode}/ndcs.json`);
        const result = await fetch(url);
        return await result.json();
      },
      ...options,
    })),
  });
